/**
 * URL input normalization for "https://" prefixed inputs (banner CTA,
 * website links, …). The input renders a static `https://` prefix and the
 * user types the bare domain; stored values always carry the protocol.
 */

export const normalizeUrl = (input: string): { url: string; suggestion: string | null } => {
  if (!input.trim()) {
    return { url: '', suggestion: null };
  }

  const trimmed = input.trim().replace(/^https?:\/\//, '');

  if (!trimmed) {
    return { url: '', suggestion: null };
  }

  // Always add https:// prefix
  const urlWithProtocol = `https://${trimmed}`;

  try {
    new URL(urlWithProtocol);
    return { url: urlWithProtocol, suggestion: null };
  } catch {
    return { url: urlWithProtocol, suggestion: 'Please enter a valid domain or URL' };
  }
};

/** Display form of a stored URL for a prefixed input (protocol stripped). */
export const stripProtocol = (value: string): string =>
  (value || '').replace(/^https?:\/\//, '');
